export { default as DocumentSeriesBottomSheet } from './DocumentSeriesBottomSheet.vue';
